import bem from 'utils/bem';

export const block = bem('save-custom-caption-style-upsell-modal');
